module.exports = __webpack_public_path__ + "static/logo-JEK-9121af8cd46ebb642aa530c34c0d129e.svg";